import React from "react";
import PageTabs from "../Common/PageTabs";

export function getTabIdByAlias(tabs = [], alias, fallbackId) {
  if (!alias) return fallbackId;

  const matchedTab = tabs.find((tab) => {
    const aliases = Array.isArray(tab.aliases) ? tab.aliases : [];
    return aliases.includes(alias);
  });

  return matchedTab?.id || fallbackId;
}

export default function SectionTabs({
  tabs = [],
  activeTab,
  onChange,
  ariaLabel = "Sections",
  className = "",
}) {
  return (
    <PageTabs
      tabs={tabs}
      activeTab={activeTab}
      onChange={onChange}
      ariaLabel={ariaLabel}
      className={className}
    />
  );
}
